import { Routes } from '@angular/router';
import { guestGuard } from '../app/core/guards/guest-guard';

export const publicRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '',
    loadComponent: () =>
      import('./layouts/public-layout/public-layout').then(m => m.PublicLayout),
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./features/home/home').then(m => m.Home)
      },
      {
        path: 'about',
        loadComponent: () =>
          import('./features/about/about').then(m => m.About)
      },
      {
        path: 'shop-now',
        loadComponent: () =>
          import('./features/shop-now/shop-now').then(m => m.ShopNow)
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./features/contact/contact').then(m => m.Contact)
      },
      {
        path: 'cart',
        loadComponent: () =>
          import('./features/cart/cart').then(m => m.Cart)
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./features/terms/terms').then(m => m.Terms)
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./features/privacy/privacy').then(m => m.Privacy)
      },
      {
        path: 'refund',
        loadComponent: () =>
          import('./features/refund/refund').then(m => m.Refund)
      },

      // {
      //   path: 'auth',
      //   canActivate: [guestGuard],
      //   children: [
      //     {
      //       path: 'login',
      //       loadComponent: () =>
      //         import('../app/features/authentication/pages/login/login').then(m => m.Login)
      //     },
      //     {
      //       path: 'register',
      //       loadComponent: () =>
      //         import('../app/features/authentication/pages/register/register').then(m => m.Register)
      //     },
      //     {
      //       path: 'register/driver',
      //       loadComponent: () =>
      //         import('../app/features/authentication/pages/driver-register/driver-register').then(m => m.DriverRegister)
      //     },
      //     {
      //       path: 'register/vendor',
      //       loadComponent: () =>
      //         import('../app/features/authentication/pages/vendor-register/vendor-register').then(m => m.VendorRegister)
      //     },
      //     {
      //       path: 'register/customer',
      //       loadComponent: () =>
      //         import('../app/features/authentication/pages/customer-register/customer-register').then(m => m.CustomerRegister)
      //     },
      //     {
      //       path: 'forgot-password',
      //       loadComponent: () =>
      //         import('../app/features/authentication/pages/forgot-password/forgot-password').then(m => m.ForgotPassword)
      //     },
      //     {
      //       path: 'reset-password',
      //       loadComponent: () =>
      //         import('../app/features/authentication/pages/reset-password/reset-password').then(m => m.ResetPassword)
      //     }
      //   ]
      // }
    ]
  },
  {
    path: '**',
    loadComponent: () =>
      import('../app/shared/components/not-found/not-found').then(m => m.NotFound)
  }
];
